import { createSlice } from "@reduxjs/toolkit";

const initialSchoolReport = {
  term: 0,
  name: "",
  description: "",
  startDate: "",
  endDate: "",
  plannedPrintDate: ""
};

const initialSchoolReportsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  moduleIds: [],
  studentIds: [],
  sectionIds: [],
  schoolReport: initialSchoolReport
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const schoolReportSlice = createSlice({
  name: "schoolReports",
  initialState: initialSchoolReportsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSchoolReports
    schoolReportsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getSchoolReport
    schoolReportFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.moduleIds = action.payload.entity.modules.map(module => module.id);
      state.modules = action.payload.entity.modules;
      state.studentIds = action.payload.entity.studentIds;
      state.sectionIds = action.payload.entity.sectionIds;
      state.schoolReport = action.payload.entity;
    },
    // getReportModules
    reportModulesFetched: (state, action) => {
      state.listLoading = false;
      state.totalCount = action.payload.length;
      state.entities = action.payload;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.studentEntities = entities;
      state.studentTotalCount = totalCount;
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sectionEntities = entities;
      state.sectionTotalCount = totalCount;
    },
    // getCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.courses = entities;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanReportModulesState
    reportModulesStateCleaned: (state) => {
      state.listLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    },
    // cleanReportStudentsState
    reportStudentsStateCleaned: (state) => {
      state.listLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.studentEntities = undefined;
      state.studentTotalCount = 0;
    },
    // cleanReportSectionsState
    reportSectionsStateCleaned: (state) => {
      state.listLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.sectionEntities = undefined;
      state.sectionTotalCount = 0;
    },
    // cleanSchoolReportsState
    schoolReportsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
      state.modules = [];
      state.studentIds = [];
      state.sectionIds = [];
      state.schoolReport = initialSchoolReport;
    }
  }
});